import { render, staticRenderFns } from "./MgeNewOrEdit.vue?vue&type=template&id=5e5c9d7b&scoped=true"
import script from "./MgeNewOrEdit.vue?vue&type=script&lang=js"
export * from "./MgeNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MgeNewOrEdit.vue?vue&type=style&index=0&id=5e5c9d7b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c9d7b",
  null
  
)

export default component.exports